export default "__VITE_ASSET__dljNwyPG__"